
export default {
  will_be_in_touch: 'Will be in touch',
  field_name: 'Contact name',
  field_email: 'Email',
  field_message: 'Leave your message',
  button_send: 'Send',
  header_manager: 'Your Affiliate Manager for VR Bangers',
}
